import { API_BASE } from "../config";

export const PAYMENT_STATUS = {
  pending: "Chờ cọc",
  received: "Đã nhận cọc",
  cancelled: "Đã hủy",
};

const MAX_AMOUNT_VND = 999999999999;

export function parseVndInput(value) {
  const input = String(value ?? "").trim();
  if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+)$/.test(input)) return null;
  const amount = Number(input.replace(/\./g, ""));
  return Number.isSafeInteger(amount) && amount > 0 && amount <= MAX_AMOUNT_VND
    ? amount
    : null;
}

export function formatVnd(value) {
  return `${new Intl.NumberFormat("vi-VN").format(value)}đ`;
}

export function paymentLink(id) {
  return `${window.location.origin}/payment/${encodeURIComponent(id)}`;
}

export function buildVietQrUrl(payment) {
  const bankBin = String(payment?.bank?.bankBin || "");
  const accountNumber = String(payment?.bank?.accountNumber || "");
  const accountName = String(payment?.bank?.accountName || "");
  const transferContent = String(payment?.transferContent || "");
  const amountVnd = payment?.amountVnd;

  if (
    !/^\d{6}$/.test(bankBin) ||
    !/^\d{6,20}$/.test(accountNumber) ||
    !accountName.trim() ||
    !transferContent.trim() ||
    !Number.isSafeInteger(amountVnd) ||
    amountVnd <= 0
  ) return null;

  const params = new URLSearchParams({
    amount: String(amountVnd),
    addInfo: transferContent,
    accountName,
  });
  return `https://img.vietqr.io/image/${bankBin}-${accountNumber}-compact2.png?${params}`;
}

export function createRequestKey() {
  // getRandomValues also works on local HTTP previews where randomUUID may not.
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

async function request(path, { token, body, headers, ...options } = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      cache: "no-store",
      credentials: "omit",
      ...options,
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        ...headers,
      },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new Error("Không thể kết nối máy chủ. Vui lòng thử lại.");
  }

  const data = await response.json().catch(() => null);
  if (!response.ok || !data) {
    const error = new Error(
      (typeof data?.error === "string" && data.error) ||
      (response.status === 401
        ? "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại."
        : "Không thể tải phiếu cọc. Vui lòng thử lại.")
    );
    error.status = response.status;
    throw error;
  }
  return data;
}

export const paymentApi = {
  list(token, { search = "", page = 1 } = {}, signal) {
    const params = new URLSearchParams({ search, page: String(page) });
    return request(`/admin/payment-requests?${params}`, { token, signal });
  },
  settings(token, signal) {
    return request("/admin/payment-requests/settings", { token, signal });
  },
  create(token, body, idempotencyKey) {
    return request("/admin/payment-requests", {
      token, method: "POST", body,
      headers: { "Idempotency-Key": idempotencyKey },
    });
  },
  updateStatus(token, id, status) {
    return request(`/admin/payment-requests/${encodeURIComponent(id)}/status`, {
      token, method: "PATCH", body: { status },
    });
  },
  getPublic(id, signal) {
    return request(`/payment-requests/${encodeURIComponent(id)}`, { signal });
  },
};
